<div class="m-quiz-not-started">
    <h3>
        The event did not start yet.
    </h3>
    <div class="row">
        <div class="col-12">Please wait for a starting time!</div>
    </div>
</div>